import { VISIT } from "../constants";

const initialState = {
    visit: null,
    visits: [],
    isLoadingVisits: false,
    createdVisit: false,
    updatedVisit: false,
    isLoadingVisit: false,
    error: null,
};

const visitReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case VISIT.VISIT_GET_ALL:
            return {
                ...state,
                isLoadingVisits: true,
                error: null,
            };
        case VISIT.VISIT_GET_ALL_FAILURE:
            return {
                ...state,
                isLoadingVisits: false,
                error: action.payload,
            };
        case VISIT.VISIT_GET_ALL_SUCCESS:
            return {
                ...state,
                isLoadingVisits: false,
                visits: action.payload,
                error: null,
            };
        case VISIT.VISIT_CREATE:
            return {
                ...state,
                createdVisit: false,
                isLoadingVisit: true,
            };
        case VISIT.VISIT_CREATE_FAILURE:
            return {
                ...state,
                isLoadingVisit: false,
                error: action.payload,
            };
        case VISIT.VISIT_CREATE_SUCCESS:
            return {
                ...state,
                createdVisit: true,
                isLoadingVisit: false,
                visit: action.payload,
                error: null,
            };
        case VISIT.VISIT_UPDATE:
            return {
                ...state,
                updatedVisit: false,
                isLoadingVisit: true,
            };
        case VISIT.VISIT_UPDATE_FAILURE:
            return {
                ...state,
                isLoadingVisit: false,
                error: action.payload,
            };
        case VISIT.VISIT_UPDATE_SUCCESS:
            return {
                ...state,
                updatedVisit: true,
                isLoadingVisit: false,
                visit: action.payload,
                error: null,
            };
        case VISIT.VISIT_DELETE:
            return {
                ...state,
                isLoadingVisit: true,
            };
        case VISIT.VISIT_DELETE_FAILURE:
            return {
                ...state,
                isLoadingVisit: false,
                error: action.payload,
            };
        case VISIT.VISIT_DELETE_SUCCESS:
            return {
                ...state,
                isLoadingVisit: false,
                visit: null,
                error: null,
            };
        case VISIT.VISIT_GET_ONE:
            return {
                ...state,
                isLoadingVisit: true,
            };
        case VISIT.VISIT_GET_ONE_FAILURE:
            return {
                ...state,
                isLoadingVisit: false,
                error: action.payload,
            };
        case VISIT.VISIT_GET_ONE_SUCCESS:
            return {
                ...state,
                isLoadingVisit: false,
                visit: action.payload,
                error: null,
            };
        default:
            return state;
    }
};

export default visitReducer;